<p-dialog
  [maximizable]="true"
  class="filters-modal"
  header="Nuevo cashout USD (Fuse / Lorum)"
  [modal]="true"
  [(visible)]="ctx.showNewTransaction"
  [style]="{ width: '1100px' }"
  *ngIf="ctx.showNewTransaction && ctx.currency == 'USD'"
  (visibleChange)="ctx.closeAddModal()"
>
  <div
    class="new-transaction-form"
    *ngIf="
      ctx.newTransactionType === 'normal' ||
      ctx.newTransactionType === 'express'
    "
  >
    <div class="form-heading">
      <div class="form-title">
        Datos del beneficiario y payload para el proveedor (se envía monto en
        unidades menores)
      </div>
      <p-button
        *ngIf="ctx.canShowCsvUpload()"
        label="Subida en lotes (.CSV)"
        severity="secondary"
        [outlined]="true"
        (click)="ctx.showCsvUpload()"
      />
    </div>
    <div class="form-scroll-wrapper">
      <form class="form-container" [formGroup]="ctx.newTransactionForm">
        <div class="form-row">
          <div class="filter-column">
            <div class="form-item">
              <label for="fuse_tx_id">ID de la transacción (opcional)</label>
              <input
                id="fuse_tx_id"
                type="number"
                formControlName="transaction_id"
                pInputText
                class="id-input-filter"
              />
            </div>
            <div class="form-item" *ngIf="ctx.auth.hasRole(ctx.roles.Admin)">
              <label for="fuse_client">Cliente asignado</label>
              <p-dropdown
                id="fuse_client"
                formControlName="client_id"
                [options]="ctx.userService.users"
                optionLabel="username"
                [filter]="true"
                filterBy="username"
                appendTo="body"
              />
            </div>
            <div class="form-item">
              <label for="fuse_tx_type">Tipo de transacción</label>
              <div class="account-type-picker">
                <div
                  *ngFor="let type of ctx.transactionTypes"
                  class="accu-type"
                  [class.selected]="
                    ctx.newTransactionForm.controls.transaction_type.value ===
                    type.id
                  "
                  (click)="ctx.setTransactionType(type.id)"
                >
                  {{ type.id }}
                </div>
                <div
                  *ngIf="!ctx.transactionTypes?.length"
                  class="accu-type selected"
                >
                  Transferencia bancaria
                </div>
              </div>
            </div>
          </div>
          <div class="filter-column">
            <div class="form-item">
              <label for="fuse_fn">Nombres</label>
              <input
                id="fuse_fn"
                type="text"
                formControlName="firstname"
                pInputText
                class="id-input-filter"
              />
            </div>
            <div class="form-item">
              <label for="fuse_ln">Apellidos</label>
              <input
                id="fuse_ln"
                type="text"
                formControlName="lastname"
                pInputText
                class="id-input-filter"
              />
            </div>
          </div>
          <div class="filter-column">
            <div class="form-item">
              <label for="fuse_amount">Monto ({{ ctx.currency }})</label>
              <input
                id="fuse_amount"
                type="number"
                formControlName="amount"
                pInputText
                class="id-input-filter"
              />
              <small class="p-text-secondary"
                >Se convierte a unidades menores (x100).</small
              >
            </div>
          </div>
        </div>

        <div class="form-title">Cuenta origen y propósito</div>
        <div class="form-row" formGroupName="fuse_payout">
          <div class="filter-column">
            <div class="form-item">
              <label for="fuse_account_id"
                >Numero de cuenta<span class="required">*</span></label
              >
              <input
                id="fuse_account_id"
                formControlName="account_id"
                pInputText
                class="id-input-filter"
                placeholder="UUID de la cuenta virtual"
              />
            </div>
            <div class="form-item">
              <label for="fuse_purpose"
                >Descripción del pago<span class="required">*</span></label
              >
              <p-dropdown
                id="fuse_purpose"
                formControlName="purpose"
                [options]="fusePayoutPurposeOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Propósito del pago"
                [filter]="true"
                filterBy="label,value"
                appendTo="body"
                styleClass="w-full"
              />
            </div>
            <div class="form-item">
              <label for="fuse_ext_ref">Referencia externa (opcional)</label>
              <input
                id="fuse_ext_ref"
                formControlName="external_reference"
                pInputText
                class="id-input-filter"
                placeholder="Si vacío: ID transacción o referencia generada"
              />
            </div>
          </div>
          <div class="filter-column">
            <div class="form-item">
              <label>Tipo beneficiario</label>
              <div class="account-type-picker">
                <div
                  class="accu-type"
                  [class.selected]="
                    ctx.newTransactionForm
                      .get('fuse_payout')
                      ?.get('beneficiary_type')?.value === 'individual'
                  "
                  (click)="setFuseBeneficiaryType('individual')"
                >
                  Individual
                </div>
                <div
                  class="accu-type"
                  [class.selected]="
                    ctx.newTransactionForm
                      .get('fuse_payout')
                      ?.get('beneficiary_type')?.value === 'corporate'
                  "
                  (click)="setFuseBeneficiaryType('corporate')"
                >
                  Business
                </div>
              </div>
            </div>
            <div class="form-item">
              <label for="fuse_rail">Medio de pago al beneficiario</label>
              <p-dropdown
                id="fuse_rail"
                formControlName="rail"
                [options]="[
                  { label: 'IBAN', value: 'iban' },
                  { label: 'Wire (cuenta + routing)', value: 'wire' },
                ]"
                optionLabel="label"
                optionValue="value"
                appendTo="body"
                (onChange)="onFuseRailChange()"
              />
            </div>
            <div
              class="form-item"
              *ngIf="
                ctx.newTransactionForm.get('fuse_payout')?.get('rail')
                  ?.value === 'wire'
              "
            >
              <label for="fuse_w_acc"
                >Wire número de cuenta<span class="required">*</span></label
              >
              <input
                id="fuse_w_acc"
                formControlName="wire_account"
                pInputText
                class="id-input-filter"
              />
            </div>
            <div
              class="form-item"
              *ngIf="
                ctx.newTransactionForm.get('fuse_payout')?.get('rail')
                  ?.value === 'iban'
              "
            >
              <label for="fuse_iban"
                >IBAN beneficiario<span class="required">*</span></label
              >
              <input
                id="fuse_iban"
                formControlName="iban"
                pInputText
                class="id-input-filter"
              />
            </div>
            <div class="form-item" *ngIf="ctx.currency === 'USD'">
              <label for="fuse_bic"
                >BIC banco beneficiario (obligatorio USD)<span class="required"
                  >*</span
                ></label
              >
              <input
                id="fuse_bic"
                formControlName="bank_bic"
                pInputText
                class="id-input-filter"
                placeholder="Código BIC/SWIFT"
              />
            </div>
          </div>
          <div class="filter-column">
            <div class="form-item">
              <label for="fuse_addr_cc"
                >País dirección<span class="required">*</span></label
              >
              <p-dropdown
                id="fuse_addr_cc"
                formControlName="address_country_code"
                [options]="ctx.countryOptions"
                optionLabel="name"
                optionValue="code"
                placeholder="País"
                [filter]="true"
                filterBy="name,code"
                appendTo="body"
              />
            </div>
            <div class="form-item">
              <label for="fuse_line1"
                >Dirección línea 1<span class="required">*</span></label
              >
              <input
                id="fuse_line1"
                formControlName="address_line_1"
                pInputText
                class="id-input-filter"
                maxlength="50"
                placeholder="Máx. 50 caracteres"
              />
            </div>
            <div
              class="form-item"
              *ngIf="
                ctx.newTransactionForm.get('fuse_payout')?.get('rail')
                  ?.value === 'wire'
              "
            >
              <label for="fuse_w_rt"
                >Wire routing<span class="required">*</span></label
              >
              <input
                id="fuse_w_rt"
                formControlName="wire_routing"
                pInputText
                class="id-input-filter"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="buttons-container">
      <p-button
        label="Cancelar"
        severity="danger"
        (click)="ctx.exitNewTransaction()"
      />
      <p-button
        label="Guardar cashout"
        [disabled]="ctx.newTransactionForm.invalid || ctx.addingTransaction"
        [loading]="ctx.addingTransaction"
        severity="secondary"
        (click)="saveTransaction()"
      />
    </div>
  </div>
  <div class="new-transaction-form" *ngIf="ctx.newTransactionType === 'csv'">
    <div class="form-heading">
      <div class="form-title">
        Selecciona el archivo .csv que contiene los cashouts a agregar
      </div>
      <a
        class="csv-template-link"
        [href]="'/csv/cashout/' + ctx.currency + '.csv'"
        [download]="ctx.currency + '.csv'"
      >
        Descargar plantilla CSV
      </a>
    </div>
    <div class="picker">
      <input
        id="cashout_csv_file_usd"
        class="csv-file-input"
        type="file"
        accept=".csv"
        (change)="ctx.onFileSelected($event)"
      />
      <label class="csv-upload-box" for="cashout_csv_file_usd">
        <span class="csv-upload-icon">
          <i class="pi pi-upload"></i>
        </span>
        <span class="csv-upload-copy">
          <span class="csv-upload-title">
            {{ ctx.selectedFile?.name || "Selecciona tu archivo CSV" }}
          </span>
          <span class="csv-upload-subtitle">
            {{
              ctx.selectedFile
                ? "Archivo listo para subir"
                : "Solo archivos .csv"
            }}
          </span>
        </span>
      </label>
      <div class="picker-actions">
        <p-button
          label="Volver al formulario"
          severity="secondary"
          [outlined]="true"
          (click)="ctx.showCashoutForm()"
        />
        <p-button
          label="Subir archivo"
          [disabled]="!ctx.selectedFile"
          [loading]="ctx.uploadingCSV"
          severity="secondary"
          (click)="ctx.uploadFile()"
        />
      </div>
    </div>
  </div>
</p-dialog>
